/* eslint-disable */

import React from 'react';
import { withCookies } from 'react-cookie';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import AddIcon from 'material-ui-icons/Add';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

import {
  ValidatorForm,
  TextValidator,
  SelectValidator,
} from 'react-material-ui-form-validator';
import MenuItem from 'material-ui/Menu/MenuItem';
import Grid from 'material-ui/Grid';
import { Row, Col } from 'react-flexbox-grid';
import Card, { CardHeader, CardContent } from 'material-ui/Card';

import InfiniteCalendar from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Input, { InputLabel } from 'material-ui/Input';
import Select from '@material-ui/core/Select';
import dataFlowIcon from '../assets/images/icons/data-flow.png';
import warningIcon from '../assets/images/icons/warning.png';
import Dialog from 'material-ui/Dialog/Dialog';
import DialogActions from 'material-ui/Dialog/DialogActions';
import DialogContent from 'material-ui/Dialog/DialogContent';
import DialogTitle from 'material-ui/Dialog/DialogTitle';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import { withRouter } from 'react-router';

import moment from 'moment';

import {
  energyDataChanged,
  demoDataAssetIdChanged,
  demoDataTypeChanged,
  createDemoData,
  updateDemoData,
  deleteDemoData,
  getDemoDataList,
  getDemoData,
  getLogList,
  getLog,
  openDemoDataFormDialog,
  closeDemoDataFormDialog,
  openDemoDataDeleteWarningDialog,
  closeDemoDataDeleteWarningDialog,
  resetDemoData,
  toggleMaintenanceStartDateDialog,
  toggleMaintenanceEndDateDialog,
  toggleActionWarningDialog,
  triggerMaintenanceScript,
  triggerGeneratePdfCertificatesReportScript,
  setMaintenanceStartDate,
  setMaintenanceEndDate,
  setSelectedTab,
  matchingOrganizationChanged,
  generatePdfCertificatesMonthlyReportOrganizationChanged,
  generatePdfCertificatesMonthlyReportStartMonthChanged,
  generatePdfCertificatesMonthlyReportStartYearChanged,
  generatePdfCertificatesMonthlyReportEndMonthChanged,
  generatePdfCertificatesMonthlyReportEndYearChanged,
  generatePdfCertificatesMonthlyReportDestinationChanged,
  actionChanged,
  commentChanged,
  uploadDataset,
  datasetChanged,
  uploadDatasetStart,
  uploadDatasetAssetMetering,
  datasetAssetMeteringChanged,
  uploadDatasetAssetMeteringStart,
  getOrganizations,
  getSelectedOrganizationBalanceAccount,
  irecDatasetChanged,
  uploadIrecDataStart,
  irecCountryChanged,
  irecYearChanged,
  irecAssetChanged,
  irecVolumeChanged,
  getCustomerOrganizationsWithIrecFeatureEnabled,
  irecCustomerOrganizationChanged,
} from '../actions';
import { translate } from 'react-i18next';
import { checkUserIsSuperAdmin } from '../utils/user/checkAdmin/CheckAdmin';
import { constants } from '../constants';
import { enums } from '../enums';

/**
 * Common component import
 */
import LoadingCircle from './commons/LoadingCircle';
import DemoDataList from './DemoDataList';
import LogList from './LogList';
import UploadAssetMetering from './Maintenance/UploadAssetMetering';
import DatabaseServiceManualAggregation from './Maintenance/DatabaseServiceManualAggregation';
import MeteringServiceManualCall from './Maintenance/MeteringServiceManualCall';

const styles = theme => ({
  tableWrapper: {
    overflowX: 'auto',
  },
  tabList: {
    borderBottom: '4px solid #F87733',
    margin: '0 0 10px',
    padding: 0,
  },
  tab: {
    fontSize: '1rem',
    fontFamily:
      '"Inter-Regular", "Avenir", "Roboto", "Helvetica", "Arial", sans-serif',
    display: 'inline-block',
    border: '1px solid transparent',
    borderBottom: 'none',
    bottom: '-1px',
    position: 'relative',
    listStyle: 'none',
    padding: '8px 16px',
    margin: '0px 24px 0px 0px',
    cursor: 'pointer',
  },
  tabSelected: {
    background: '#F87733',
    borderColor: '#F87733',
    color: 'white',
    borderRadius: '0px 0px 0 0',
  },
  tabDisabled: {
    color: 'black',
    cursor: 'default',
  },
});

class Maintenance extends React.Component {
  componentDidMount = async () => {
    const { isAuthenticated, user } = this.props;

    if (checkUserIsSuperAdmin(isAuthenticated, user)) {
      // custom rule will have name 'isBlockchainAddress'
      ValidatorForm.addValidationRule('isAnArray', value => {
        try {
          if (JSON.parse(value)) {
            return true;
          } else {
            return false;
          }
        } catch (error) {
          console.error(error);
          return false;
        }
      });

      ValidatorForm.addValidationRule('isA30String', value => {
        try {
          if (value && value.length >= 20) {
            return true;
          } else {
            return false;
          }
        } catch (error) {
          console.error(error);
          return false;
        }
      });

      ValidatorForm.addValidationRule('isA30ItemsArray', value => {
        try {
          if (JSON.parse(value)) {
            const energyDataArray = JSON.parse(value);
            if (energyDataArray && energyDataArray.length === 30) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } catch (error) {
          console.error(error);
          return false;
        }
      });

      ValidatorForm.addValidationRule('isA30NumbersArray', value => {
        try {
          if (JSON.parse(value)) {
            const energyDataArray = JSON.parse(value);
            let onlyNumbers = true;
            energyDataArray.forEach((data, index) => {
              if (isNaN(data)) {
                onlyNumbers = false;
              }
            });
            if (
              energyDataArray &&
              energyDataArray.length === 30 &&
              onlyNumbers
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } catch (error) {
          console.error(error);
          return false;
        }
      });

      await this.props.getDemoDataList();
      await this.props.getLogList();
      await this.props.getOrganizations();
      await this.props.getCustomerOrganizationsWithIrecFeatureEnabled();
    } else {
      this.props.history.push('/');
    }
  };

  handleActionChange = () => event => {
    this.props.actionChanged(event.target.value);
  };

  handleCommentChange = () => event => {
    this.props.commentChanged(event.target.value);
  };

  handleLaunchMaintenanceScript = async () => {
    const {
      startDate,
      endDate,
      organizationId,
      actionId,
      comment,
    } = this.props;
    await this.props.triggerMaintenanceScript(
      startDate,
      endDate,
      organizationId,
      actionId,
      comment
    );
    await this.props.getLogList();
  };

  handleLaunchGeneratePdfCertificatesScript = async () => {
    const {
      startMonthForMonthlyReport,
      startYearForMonthlyReport,
      endMonthForMonthlyReport,
      endYearForMonthlyReport,
      organizationForMonthlyReportId,
      destinationForMonthlyReport,
    } = this.props;
    console.log({
      startMonthForMonthlyReport,
      startYearForMonthlyReport,
      endMonthForMonthlyReport,
      endYearForMonthlyReport,
      organizationForMonthlyReportId,
      destinationForMonthlyReport,
    });
    await this.props.triggerGeneratePdfCertificatesReportScript(
      startMonthForMonthlyReport,
      startYearForMonthlyReport,
      endMonthForMonthlyReport,
      endYearForMonthlyReport,
      organizationForMonthlyReportId,
      destinationForMonthlyReport
    );
  };

  handleMatchingOrganizationChange = () => event => {
    this.props.matchingOrganizationChanged(event.target.value);
  };

  handleGeneratePdfCertificatesMonthlyReportOrganizationChange = () => event => {
    this.props.generatePdfCertificatesMonthlyReportOrganizationChanged(
      event.target.value
    );
  };

  handleGeneratePdfCertificatesMonthlyReportStartMonthChange = () => event => {
    this.props.generatePdfCertificatesMonthlyReportStartMonthChanged(
      event.target.value
    );
  };

  handleGeneratePdfCertificatesMonthlyReportStartYearChange = () => event => {
    this.props.generatePdfCertificatesMonthlyReportStartYearChanged(
      event.target.value
    );
  };

  handleGeneratePdfCertificatesMonthlyReportEndMonthChange = () => event => {
    this.props.generatePdfCertificatesMonthlyReportEndMonthChanged(
      event.target.value
    );
  };

  handleGeneratePdfCertificatesMonthlyReportEndYearChange = () => event => {
    this.props.generatePdfCertificatesMonthlyReportEndYearChanged(
      event.target.value
    );
  };

  handleGeneratePdfCertificatesMonthlyReportDestinationChange = () => event => {
    this.props.generatePdfCertificatesMonthlyReportDestinationChanged(
      event.target.value
    );
  };

  handleEnergyDataChange = () => event => {
    this.props.energyDataChanged(event.target.value);
  };

  handleAssetIdChange = () => event => {
    this.props.demoDataAssetIdChanged(event.target.value);
  };

  handleTypeChange = () => event => {
    this.props.demoDataTypeChanged(event.target.value);
  };

  handleTypeChange = () => event => {
    this.props.demoDataTypeChanged(event.target.value);
  };

  handleSubmitForm = async update => {
    if (update) {
      await this.props.updateDemoData(this.props.demoData);
    } else {
      await this.props.createDemoData(this.props.demoData);
    }
    await this.props.getDemoDataList();
    this.props.closeDemoDataFormDialog();
  };

  onDrop = async file => {
    this.props.uploadDataset(file);
  };

  onDropAssetMeteringFile = async file => {
    this.props.uploadDatasetAssetMetering(file);
  };

  handleDatasetChange = event => {
    this.props.datasetChanged(event.target.files[0]);
  };

  handleDatasetAssetMeteringChange = event => {
    this.props.datasetAssetMeteringChanged(event.target.files[0]);
  };

  handleDeleteDemoData = async demoData => {
    if (demoData && demoData._id) {
      await this.props.deleteDemoData(demoData);
      await this.props.getDemoDataList();
      this.props.closeDemoDataDeleteWarningDialog();
    } else {
      alert('demo data is not defined');
    }
  };

  renderMatchingForm() {
    const {
      classes,
      loadingMaintenanceAction,
      loadingBalance,
      selectedOrganizationBalanceAccount,
      startDate,
      endDate,
      utilityOrganizations,
      organizationId,
      comment,
      t,
      cookies,
    } = this.props;

    let csrfToken = cookies.cookies._csrf;
    let numberOfDays = moment(endDate).diff(startDate, 'days') + 1;
    let selectedOrganization = null;
    let organizationName = '-';

    if (organizationId) {
      if (organizationId !== enums.MaintenanceOrganization.ALL) {
        selectedOrganization = utilityOrganizations.find(organization => {
          return organization._id === organizationId;
        });
        organizationName = selectedOrganization.name;
      }
    }

    return (
      <div>
        <Card className={classes.card} style={{ marginTop: 40 }}>
          <CardHeader title={t('Maintenance actions')} />
          <CardContent>
            <Grid item xs={12}>
              <ValidatorForm
                ref="form-matching"
                onSubmit={() => {
                  this.handleSubmitFormMatching(update);
                }}
                onError={errors => console.log(errors)}
                className={classNames(classes.margin, classes.textField)}
                style={{ marginLeft: 8 }}
              >
                <Row>
                  <Col xs={12}>
                    <Row>
                      <div style={{ marginTop: 39, marginRight: 20 }}>
                        <Typography
                          variant="caption"
                          style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                        >
                          {t('Trigger')}
                        </Typography>
                      </div>
                      <input type="hidden" name="_csrf" value={{ csrfToken }} />
                      <SelectValidator
                        style={{ width: 300 }}
                        id="select-action"
                        label={t('Select action')}
                        className={classes.textField}
                        value={
                          this.props.actionId
                            ? this.props.actionId
                            : 'matching_live'
                        }
                        validators={['required']}
                        errorMessages={['Action is required']}
                        onChange={this.handleActionChange()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        {constants.MaintenanceActionTypes.map(action => (
                          <MenuItem key={action.value} value={action.value}>
                            {action.label}
                          </MenuItem>
                        ))}
                      </SelectValidator>
                    </Row>
                    <Row>
                      <div style={{ marginTop: 39, marginRight: 20 }}>
                        <Typography
                          variant="caption"
                          style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                        >
                          {t('for')}
                        </Typography>
                      </div>
                      <SelectValidator
                        style={{ width: 300 }}
                        id="select-organization"
                        label={t('Select organization')}
                        className={classes.textField}
                        value={
                          this.props.organizationId
                            ? this.props.organizationId
                            : ''
                        }
                        validators={['required']}
                        errorMessages={['Organization is required']}
                        onChange={this.handleMatchingOrganizationChange()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        {
                          <MenuItem key="" value="">
                            -
                          </MenuItem>
                        }
                        {utilityOrganizations.map(organization => (
                          <MenuItem
                            key={organization._id}
                            value={organization._id}
                          >
                            {organization.name}
                          </MenuItem>
                        ))}
                      </SelectValidator>
                    </Row>
                    <Row style={{ marginTop: 20 }}>
                      <div
                        style={{
                          marginTop: 20,
                          marginRight: 20,
                          float: 'left',
                        }}
                      >
                        <Typography
                          variant="caption"
                          style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                        >
                          {t('between')}
                        </Typography>
                      </div>
                      <div style={{ marginRight: 15, float: 'left' }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            format="dd/MM/yyyy"
                            openTo={'year'}
                            id="maintenance-start-date"
                            label="Start date"
                            value={this.props.startDate}
                            onChange={newDate => {
                              if (!moment(newDate).isValid() || !newDate) {
                                newDate = null;
                              }

                              this.props.setMaintenanceStartDate(newDate);
                            }}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            className={classes.inputWithMargin}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                      <div style={{ marginRight: 15, float: 'left' }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            format="dd/MM/yyyy"
                            openTo={'year'}
                            id="maintenance-end-date"
                            label="End date"
                            value={this.props.endDate}
                            onChange={newDate => {
                              if (!moment(newDate).isValid() || !newDate) {
                                newDate = null;
                              }

                              this.props.setMaintenanceEndDate(newDate);
                            }}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            className={classes.inputWithMargin}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </Row>
                    <Row style={{ marginTop: 20 }}>
                      <Button
                        type="submit"
                        variant="raised"
                        color="primary"
                        onClick={() => {
                          this.props.getSelectedOrganizationBalanceAccount(
                            this.props.organizationId
                          );
                          this.props.toggleActionWarningDialog();
                        }}
                        disabled={
                          !this.props.organizationId ||
                          !this.props.startDate ||
                          !this.props.endDate
                        }
                      >
                        {t('Launch')}
                      </Button>
                    </Row>
                  </Col>
                </Row>
              </ValidatorForm>
            </Grid>
          </CardContent>
        </Card>
        <Dialog
          fullScreen={false}
          open={this.props.dialogStartDateOpen}
          onClose={this.props.toggleMaintenanceStartDateDialog}
          aria-labelledby="startdate-dialog"
        >
          <DialogTitle id="startdate-dialog">{t('Start date')}</DialogTitle>
          <DialogContent>
            <InfiniteCalendar
              width={400}
              height={600}
              display={'years'}
              selected={this.props.startDate}
              onSelect={selectedStartDate => {
                this.props.setMaintenanceStartDate(selectedStartDate);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.toggleMaintenanceStartDateDialog}
              color="primary"
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullScreen={false}
          open={this.props.dialogEndDateOpen}
          onClose={this.props.toggleMaintenanceEndDateDialog}
          aria-labelledby="enddate-dialog"
        >
          <DialogTitle id="enddate-dialog">{t('End date')}</DialogTitle>
          <DialogContent>
            <InfiniteCalendar
              width={400}
              height={600}
              display={'years'}
              selected={this.props.endDate}
              onSelect={selectedEndDate => {
                this.props.setMaintenanceEndDate(selectedEndDate);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.toggleMaintenanceEndDateDialog}
              color="primary"
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullScreen={false}
          open={this.props.dialogWarningOpen}
          onClose={this.props.toggleActionWarningDialog}
          aria-labelledby="startdate-dialog"
        >
          <DialogTitle id="startdate-dialog">
            <img
              src={warningIcon}
              alt={'Be careful'}
              title={'Be careful'}
              style={{ width: 24, height: 24 }}
            />{' '}
            {t('Check your parameters')}
          </DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: 10 }}>
              {t(
                'You will trigger a maintenance script, please check carefully before launching'
              )}
            </div>
            <div>
              <Typography
                variant="body1"
                style={{ color: 'rgba(0, 0, 0, 0.54)' }}
              >
                {t('Type of script')} :{' '}
                <span style={{ color: 'rgba(0, 0, 0, 1)', fontWeight: 'bold' }}>
                  {this.props.actionId}
                </span>
              </Typography>
            </div>
            <div>
              <Typography
                variant="body1"
                style={{ color: 'rgba(0, 0, 0, 0.54)' }}
              >
                {t('Organization')} :{' '}
                <span style={{ color: 'rgba(0, 0, 0, 1)', fontWeight: 'bold' }}>
                  {organizationName}
                </span>
                {loadingBalance && (
                  <LoadingCircle type="buttonProgress" classes={classes} />
                )}
                {selectedOrganizationBalanceAccount && !loadingBalance && (
                  <span> {selectedOrganizationBalanceAccount} ETH</span>
                )}
              </Typography>
            </div>
            <div>
              <Typography
                variant="body1"
                style={{ color: 'rgba(0, 0, 0, 0.54)' }}
              >
                {t('Dates')} :{' '}
                <span style={{ color: 'rgba(0, 0, 0, 1)', fontWeight: 'bold' }}>
                  {moment(this.props.startDate).format('DD/MM/YYYY')} ->{' '}
                  {moment(this.props.endDate).format('DD/MM/YYYY')} (
                  {numberOfDays} days)
                </span>
              </Typography>
            </div>
            <div>
              <ValidatorForm
                ref="form-comment"
                onError={errors => console.log(errors)}
                className={classNames(classes.margin, classes.textField)}
              >
                <TextValidator
                  style={{ width: '100%', marginTop: 20 }}
                  label={t(
                    "Give us an explanation about why you're doing this !"
                  )}
                  onChange={this.handleCommentChange()}
                  name="comment"
                  value={comment ? comment : ''}
                  validators={['isA30String', 'required']}
                  errorMessages={[
                    'Give a longer explanation',
                    'A comment data is required',
                  ]}
                />
              </ValidatorForm>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={this.props.toggleActionWarningDialog}
              color="primary"
              component="span"
              className={classes.button}
              style={{
                marginRight: 20,
                border: '1px solid rgba(248,119,51, 0.5)',
                borderRadius: 4,
              }}
            >
              {t('Close')}
            </Button>
            <Button
              type="submit"
              color="secondary"
              variant="raised"
              onClick={() => {
                this.handleLaunchMaintenanceScript();
              }}
              disabled={
                loadingMaintenanceAction || !comment || comment.length < 20
              }
            >
              {t('Launch script in background')}
            </Button>
            {loadingMaintenanceAction && (
              <LoadingCircle type="buttonProgress" classes={classes} />
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderGenerateMonthyReportForm() {
    const {
      classes,
      loadingGenerateMonthlyReportAction,
      startMonthForMonthlyReport,
      endMonthForMonthlyReport,
      startYearForMonthlyReport,
      endYearForMonthlyReport,
      destinationForMonthlyReport,
      organizationForMonthlyReportId,
      organizationsForMonthlyReport,
      t,
    } = this.props;

    let selectedOrganization = null;
    let organizationName = '-';

    if (organizationForMonthlyReportId) {
      selectedOrganization = organizationsForMonthlyReport.find(
        organization => {
          return organization._id === organizationForMonthlyReportId;
        }
      );
      organizationName = selectedOrganization.name;
    }

    //Build years array for pdf certificates report
    let years = [];

    let currentYear = moment().format('YYYY');
    let firstYear = 2020;

    for (let year = firstYear; year <= currentYear; year++) {
      years.push(year);
    }

    //Build months array for pdf certificates report
    let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    return (
      <div>
        <Card className={classes.card} style={{ marginTop: 40 }}>
          <CardHeader title={t('Generate PDF monthly reports')} />
          <CardContent>
            <Grid item xs={12}>
              <ValidatorForm
                ref="form-pdf-certificates-generation"
                onSubmit={() => {
                  console.log('ValidatorForm onSubmit for pdf generation');
                }}
                onError={errors => console.log(errors)}
                className={classNames(classes.margin, classes.textField)}
                style={{ marginLeft: 8 }}
              >
                <Row>
                  <Col xs={12}>
                    <Row>
                      <div style={{ marginTop: 39, marginRight: 20 }}>
                        <Typography
                          variant="caption"
                          style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                        >
                          {t('For')}
                        </Typography>
                      </div>
                      <SelectValidator
                        style={{ width: 300 }}
                        id="select-organization-pdf-certificates-generation"
                        label={t('Select organization')}
                        className={classes.textField}
                        value={
                          organizationForMonthlyReportId
                            ? organizationForMonthlyReportId
                            : organizationsForMonthlyReport &&
                              organizationsForMonthlyReport.length > 0
                            ? organizationsForMonthlyReport[0]._id
                            : null
                        }
                        validators={['required']}
                        errorMessages={['Organization is required']}
                        onChange={this.handleGeneratePdfCertificatesMonthlyReportOrganizationChange()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        {organizationsForMonthlyReport.map(organization => (
                          <MenuItem
                            key={organization._id}
                            value={organization._id}
                          >
                            {organization.name}
                          </MenuItem>
                        ))}
                      </SelectValidator>
                    </Row>

                    <Row style={{ marginTop: 20, paddingLeft: 44 }}>
                      <SelectValidator
                        style={{ width: 100 }}
                        id="select-start-month-pdf-certificates-generation"
                        label={t('Start month')}
                        className={classes.textField}
                        value={
                          startMonthForMonthlyReport
                            ? startMonthForMonthlyReport
                            : moment()
                                .subtract(1, 'month')
                                .format('M')
                        }
                        validators={['required']}
                        errorMessages={['Start month is required']}
                        onChange={this.handleGeneratePdfCertificatesMonthlyReportStartMonthChange()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        {months.map(m => (
                          <MenuItem key={`startMonth${m}`} value={m}>
                            {m}
                          </MenuItem>
                        ))}
                      </SelectValidator>

                      <SelectValidator
                        style={{ width: 100 }}
                        id="select-start-year-pdf-certificates-generation"
                        label={t('Start year')}
                        className={classes.textField}
                        value={
                          startYearForMonthlyReport
                            ? startYearForMonthlyReport
                            : moment()
                                .subtract(1, 'month')
                                .format('YYYY')
                        }
                        validators={['required']}
                        errorMessages={['Start year is required']}
                        onChange={this.handleGeneratePdfCertificatesMonthlyReportStartYearChange()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        {years.map(y => (
                          <MenuItem key={`startYear${y}`} value={y}>
                            {y}
                          </MenuItem>
                        ))}
                      </SelectValidator>
                    </Row>
                    <Row style={{ marginTop: 20, paddingLeft: 44 }}>
                      <SelectValidator
                        style={{ width: 100 }}
                        id="select-end-month-pdf-certificates-generation"
                        label={t('End month')}
                        className={classes.textField}
                        value={
                          endMonthForMonthlyReport
                            ? endMonthForMonthlyReport
                            : moment()
                                .subtract(1, 'month')
                                .format('M')
                        }
                        validators={['required']}
                        errorMessages={['End month is required']}
                        onChange={this.handleGeneratePdfCertificatesMonthlyReportEndMonthChange()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        {months.map(m => (
                          <MenuItem key={`endMonth${m}`} value={m}>
                            {m}
                          </MenuItem>
                        ))}
                      </SelectValidator>

                      <SelectValidator
                        style={{ width: 100 }}
                        id="select-end-year-pdf-certificates-generation"
                        label={t('End year')}
                        className={classes.textField}
                        value={
                          endYearForMonthlyReport
                            ? endYearForMonthlyReport
                            : moment()
                                .subtract(1, 'month')
                                .format('YYYY')
                        }
                        validators={['required']}
                        errorMessages={['End year is required']}
                        onChange={this.handleGeneratePdfCertificatesMonthlyReportEndYearChange()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        {years.map(y => (
                          <MenuItem key={`startYear${y}`} value={y}>
                            {y}
                          </MenuItem>
                        ))}
                      </SelectValidator>
                    </Row>
                    <Row style={{ marginTop: 20, paddingLeft: 44 }}>
                      <SelectValidator
                        style={{ width: 100 }}
                        id="select-destination-pdf-certificates-generation"
                        label={t('Destination')}
                        className={classes.textField}
                        value={
                          destinationForMonthlyReport
                            ? destinationForMonthlyReport
                            : 'local'
                        }
                        validators={['required']}
                        errorMessages={['Destination is required']}
                        onChange={this.handleGeneratePdfCertificatesMonthlyReportDestinationChange()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        <MenuItem key={`destination-local`} value={'local'}>
                          {'local'}
                        </MenuItem>
                        <MenuItem key={`destination-s3`} value={'s3'}>
                          {'S3'}
                        </MenuItem>
                      </SelectValidator>
                    </Row>
                  </Col>
                </Row>
              </ValidatorForm>
              <Row>
                <Col xs={12}>
                  <Button
                    type="submit"
                    color="primary"
                    variant="raised"
                    onClick={() => {
                      this.handleLaunchGeneratePdfCertificatesScript();
                    }}
                    disabled={loadingGenerateMonthlyReportAction}
                  >
                    {t('Generate PDF certificates')}
                  </Button>
                  {loadingGenerateMonthlyReportAction && (
                    <LoadingCircle type="buttonProgress" classes={classes} />
                  )}
                </Col>
              </Row>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }

  handleIrecDatasetChange = event => {
    this.props.irecDatasetChanged(event.target.files[0]);
  };

  handleIrecCountryChange = () => event => {
    this.props.irecCountryChanged(event.target.value);
  };

  handleIrecYearChange = date => {
    const year = moment(date).format('YYYY');
    this.props.irecYearChanged(year);
  };

  handleIrecAssetChange = () => event => {
    this.props.irecAssetChanged(event.target.value);
  };

  handleIrecVolumeChange = () => event => {
    this.props.irecVolumeChanged(event.target.value);
  };

  handleIrecCustomerOrganizationChange = () => event => {
    this.props.irecCustomerOrganizationChanged(event.target.value);
  };

  render() {
    const {
      classes,
      loading,
      loadingOrganizations,
      selectedTab,
      setSelectedTab,
      loadingDataset,
      loadingDatasetAssetMetering,
      demoData,
      t,
      utilityOrganizations,
      i18n,
      loadingIrecDataset,
      customerOrganizationsWithIrecFeatureEnabled,
    } = this.props;

    let update = false;
    if (demoData._id) update = true;

    if (
      !utilityOrganizations ||
      utilityOrganizations.length < 1 ||
      loadingOrganizations
    ) {
      return <LoadingCircle type="buttonProgress" classes={classes} />;
    }

    const handleChange = newValue => {
      setSelectedTab(newValue);
    };

    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Tabs>
              <TabList
                selectedIndex={selectedTab}
                onSelect={(currentTab, lastTab) => handleChange(currentTab)}
              >
                <Tab
                  className={classes.tab}
                  disabledClassName={classes.tabDisabled}
                  selectedClassName={classes.tabSelected}
                >
                  Matching
                </Tab>
                <Tab
                  className={classes.tab}
                  disabledClassName={classes.tabDisabled}
                  selectedClassName={classes.tabSelected}
                >
                  Aggregations
                </Tab>
                <Tab
                  className={classes.tab}
                  disabledClassName={classes.tabDisabled}
                  selectedClassName={classes.tabSelected}
                >
                  Data Acquisition
                </Tab>
                <Tab
                  className={classes.tab}
                  disabledClassName={classes.tabDisabled}
                  selectedClassName={classes.tabSelected}
                >
                  Data Uploader
                </Tab>
                <Tab
                  className={classes.tab}
                  disabledClassName={classes.tabDisabled}
                  selectedClassName={classes.tabSelected}
                >
                  Logs
                </Tab>
                <Tab
                  className={classes.tab}
                  disabledClassName={classes.tabDisabled}
                  selectedClassName={classes.tabSelected}
                >
                  Demo Data
                </Tab>
                <Tab
                  className={classes.tab}
                  disabledClassName={classes.tabDisabled}
                  selectedClassName={classes.tabSelected}
                >
                  iRec
                </Tab>
                <Tab
                  className={classes.tab}
                  disabledClassName={classes.tabDisabled}
                  selectedClassName={classes.tabSelected}
                >
                  PDF Report
                </Tab>
              </TabList>

              <TabPanel value={selectedTab} index={0}>
                {this.renderMatchingForm()}
              </TabPanel>
              <TabPanel value={selectedTab} index={1}>
                <DatabaseServiceManualAggregation />
              </TabPanel>
              <TabPanel value={selectedTab} index={2}>
                <MeteringServiceManualCall />
              </TabPanel>
              <TabPanel value={selectedTab} index={3}>
                <Card className={classes.card} style={{ marginTop: 40 }}>
                  <CardHeader title={t('Data uploader')} />
                  <CardContent>
                    <Grid item xs={12}>
                      <Row>
                        <Col xs={12}>
                          <div style={{ float: 'left' }}>
                            <input
                              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                              className={classes.input}
                              id="upload-button-file"
                              multiple
                              type="file"
                              style={{ display: 'none' }}
                              onChange={this.handleDatasetChange.bind(this)}
                              onDrop={this.onDrop.bind(this)}
                            />
                            <label htmlFor="upload-button-file">
                              <Button
                                variant="outlined"
                                color="primary"
                                component="span"
                                className={classes.button}
                                disabled={loadingDataset}
                                style={{
                                  marginTop: 13,
                                  border: '1px solid rgba(248,119,51, 0.5)',
                                  borderRadius: 4,
                                }}
                              >
                                Select Demo Dataset
                              </Button>
                            </label>
                          </div>
                          <div style={{ float: 'left', marginTop: 24 }}>
                            <Typography
                              variant="caption"
                              style={{
                                color: 'rgba(0, 0, 0, 0.54)',
                                marginLeft: 10,
                              }}
                            >
                              {this.props.localDataset &&
                              this.props.localDataset.name
                                ? this.props.localDataset.name
                                : 'No file selected'}
                            </Typography>
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 20 }}>
                        <Col xs={12}>
                          <Button
                            variant="raised"
                            color="primary"
                            disabled={
                              loadingDataset ||
                              !this.props.localDataset ||
                              !this.props.localDataset.name
                            }
                            onClick={() => {
                              this.props.uploadDatasetStart(
                                this.props.localDataset
                              );
                            }}
                          >
                            Upload demo dataset
                          </Button>
                          {loadingDataset && (
                            <LoadingCircle
                              type="buttonProgress"
                              classes={classes}
                            />
                          )}
                        </Col>
                      </Row>
                      <div />
                    </Grid>
                  </CardContent>
                </Card>
                <UploadAssetMetering disabled={loadingDatasetAssetMetering} />
              </TabPanel>
              <TabPanel value={selectedTab} index={5}>
                <Card className={classes.card}>
                  <CardHeader title={t('Logs')} />
                  <CardContent>
                    <Grid item xs={12}>
                      <Row>
                        <Col xs={12}>
                          <LogList {...this.props} />
                        </Col>
                      </Row>
                    </Grid>
                  </CardContent>
                </Card>
              </TabPanel>
              <TabPanel value={selectedTab} index={6}>
                <Row style={{ float: 'right' }}>
                  <div style={{ height: 0 }}>
                    <Button
                      variant="fab"
                      color="primary"
                      aria-label="add"
                      className={classes.button}
                      style={{
                        margin: 0,
                        right: 28,
                        top: 13,
                        position: 'relative',
                      }}
                      onClick={() => {
                        this.props.openDemoDataFormDialog();
                      }}
                    >
                      <AddIcon />
                    </Button>
                  </div>
                </Row>
                <Card className={classes.card}>
                  <CardHeader title={t('Demo Data')} />
                  <CardContent>
                    <Grid item xs={12}>
                      <Row>
                        <Col xs={12}>
                          <DemoDataList {...this.props} />
                        </Col>
                      </Row>
                    </Grid>
                  </CardContent>
                  <Dialog
                    fullScreen={false}
                    open={this.props.demoDataFormOpen}
                    onClose={() => {
                      this.props.closeDemoDataFormDialog();
                    }}
                    aria-labelledby="demo-data-form-dialog"
                  >
                    <DialogTitle id="demo-data-form-dialog">
                      {update ? t('Update demo data') : t('Create demo data')}
                    </DialogTitle>
                    <DialogContent>
                      <Typography variant="body2" gutterBottom>
                        {update
                          ? t('Upload a new dataset for ') +
                            ' ' +
                            demoData.assetID
                          : t('Create a new demo dataset')}
                      </Typography>
                      <ValidatorForm
                        ref="form"
                        onSubmit={() => {
                          this.handleSubmitForm(update);
                        }}
                        onError={errors => console.log(errors)}
                        className={classNames(
                          classes.margin,
                          classes.textField
                        )}
                      >
                        <Grid item xs={12}>
                          <Row>
                            <Col xs={12}>
                              <TextValidator
                                style={{ width: 300, marginTop: 20 }}
                                label={t(
                                  'Energy data (Array of 30 numbers, in MWh)'
                                )}
                                onChange={this.handleEnergyDataChange()}
                                name="energy_data"
                                value={
                                  demoData.energy
                                    ? JSON.stringify(demoData.energy)
                                    : '[]'
                                }
                                validators={[
                                  'isAnArray',
                                  'isA30ItemsArray',
                                  'isA30NumbersArray',
                                  'required',
                                ]}
                                errorMessages={[
                                  'Insert an array Ex: [123, 123.45, 678.9]',
                                  'Insert an array of 30 items',
                                  'Insert an array of 30 numbers',
                                  'Energy data is required',
                                ]}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <TextValidator
                                style={{ width: 300, marginTop: 20 }}
                                label={t('AssetID')}
                                onChange={this.handleAssetIdChange()}
                                name="asset_id"
                                value={demoData.assetID ? demoData.assetID : ''}
                                validators={['required']}
                                errorMessages={['AssetID is required']}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12}>
                              <SelectValidator
                                style={{ width: 300 }}
                                id="select-type"
                                label={t('Type')}
                                className={classes.textField}
                                value={
                                  this.props.demoData.production_type
                                    ? this.props.demoData.production_type
                                    : 'Production'
                                }
                                validators={['required']}
                                errorMessages={['Type is required']}
                                onChange={this.handleTypeChange()}
                                SelectProps={{
                                  MenuProps: {
                                    className: classes.menu,
                                  },
                                }}
                                margin="normal"
                              >
                                {constants.ConsumptionTypes.map(type => (
                                  <MenuItem key={type.value} value={type.value}>
                                    {type.label}
                                  </MenuItem>
                                ))}
                              </SelectValidator>
                            </Col>
                          </Row>

                          <Row style={{ marginTop: 20 }}>
                            <Button
                              variant="outlined"
                              onClick={() => {
                                this.props.closeDemoDataFormDialog();
                              }}
                              color="primary"
                              component="span"
                              className={classes.button}
                              style={{
                                marginRight: 20,
                                border: '1px solid rgba(248,119,51, 0.5)',
                                borderRadius: 4,
                              }}
                            >
                              {t('Close')}
                            </Button>
                            <Button
                              type="submit"
                              variant="raised"
                              color="primary"
                              disabled={loading}
                            >
                              {update
                                ? t('Update demo data')
                                : t('Create demo data')}
                            </Button>
                            {loading && (
                              <LoadingCircle
                                type="buttonProgress"
                                classes={classes}
                              />
                            )}
                          </Row>
                        </Grid>
                      </ValidatorForm>
                    </DialogContent>
                  </Dialog>

                  <Dialog
                    fullScreen={false}
                    open={this.props.demoDataDeleteWarningOpen}
                    onClose={() => {
                      this.props.closeDemoDataDeleteWarningDialog();
                    }}
                    aria-labelledby="demo-data-delete-warning-dialog"
                  >
                    <DialogTitle id="demo-data-delete-warning-dialog">
                      {t('Delete the demo data')}
                    </DialogTitle>
                    <DialogContent>
                      <Typography variant="body2" gutterBottom>
                        {t('Delete this data set ?')}{' '}
                        {this.props.demoData.assetID}
                      </Typography>
                      <Grid item xs={12}>
                        <Row style={{ marginTop: 20 }}>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              this.props.closeDemoDataDeleteWarningDialog();
                            }}
                            color="primary"
                            component="span"
                            className={classes.button}
                            style={{
                              marginRight: 20,
                              border: '1px solid rgba(248,119,51, 0.5)',
                              borderRadius: 4,
                            }}
                          >
                            {t('Close')}
                          </Button>
                          <Button
                            type="submit"
                            variant="raised"
                            color="primary"
                            onClick={() => {
                              this.closeDemoDataDeleteWarningDialog();
                            }}
                            disabled={loading}
                          >
                            {t('Delete demo data')}
                          </Button>
                          {loading && (
                            <LoadingCircle
                              type="buttonProgress"
                              classes={classes}
                            />
                          )}
                        </Row>
                      </Grid>
                    </DialogContent>
                  </Dialog>
                </Card>
              </TabPanel>
              <TabPanel value={selectedTab} index={7}>
                <Card className={classes.card} style={{ marginTop: 40 }}>
                  <CardHeader
                    avatar={
                      <img src={dataFlowIcon} style={{ maxHeight: 20 }} />
                    }
                    title={t('iRec data uploader')}
                  />
                  <CardContent>
                    <Grid item xs={12} sm={12}>
                      <Row className={classes.indentedContent}>
                        <Col>
                          <FormControl
                            className={classes.inputWithMargin}
                            style={{ marginTop: 20, marginRight: 20 }}
                          >
                            <InputLabel htmlFor="adornment-country">
                              Country
                            </InputLabel>
                            <Input
                              id="adornment-country"
                              type="text"
                              value={this.props.irecCountry}
                              onChange={this.handleIrecCountryChange()}
                            />
                          </FormControl>
                        </Col>
                        <Col>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              style={{ marginRight: 20, marginTop: 20 }}
                              margin="normal"
                              id="time-picker"
                              label="Year"
                              openTo={'year'}
                              value={this.props.irecYear}
                              onChange={newDate => {
                                if (!moment(newDate).isValid() || !newDate) {
                                  newDate = null;
                                }
                                this.handleIrecYearChange(newDate);
                              }}
                              views={['year']}
                              KeyboardButtonProps={{
                                'aria-label': 'change year',
                              }}
                              className={classes.inputWithMargin}
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col>
                          <FormControl
                            className={classes.inputWithMargin}
                            style={{ marginTop: 20, marginRight: 20 }}
                          >
                            <InputLabel htmlFor="adornment-asset">
                              Asset
                            </InputLabel>
                            <Input
                              id="adornment-asset"
                              type="text"
                              value={this.props.irecAsset}
                              onChange={this.handleIrecAssetChange()}
                            />
                          </FormControl>
                        </Col>
                        <Col>
                          <FormControl
                            className={classes.inputWithMargin}
                            style={{ marginTop: 20, marginRight: 20 }}
                          >
                            <InputLabel htmlFor="adornment-volume">
                              Volume
                            </InputLabel>
                            <Input
                              id="adornment-volume"
                              type="number"
                              value={this.props.irecVolume}
                              onChange={this.handleIrecVolumeChange()}
                              inputProps={{ min: '0', step: '1' }}
                            />
                          </FormControl>
                        </Col>
                        <Col>
                          <FormControl
                            className={classes.inputWithMargin}
                            style={{ marginTop: 35, minWidth: 120 }}
                          >
                            <Select
                              labelId="adornment-customer-organization"
                              value={this.props.irecCustomerOrganization}
                              onChange={this.handleIrecCustomerOrganizationChange()}
                            >
                              {customerOrganizationsWithIrecFeatureEnabled.map(
                                customerOrganization => (
                                  <MenuItem
                                    key={customerOrganization._id}
                                    value={customerOrganization._id}
                                  >
                                    {customerOrganization.name}
                                  </MenuItem>
                                )
                              )}
                            </Select>
                            <FormHelperText>
                              CustomerOrganization
                            </FormHelperText>
                          </FormControl>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12}>
                          <div style={{ float: 'left' }}>
                            <input
                              accept="application/pdf"
                              className={classes.input}
                              id="upload-button-file"
                              multiple
                              type="file"
                              style={{ display: 'none' }}
                              onChange={this.handleIrecDatasetChange.bind(this)}
                            />
                            <label htmlFor="upload-button-file">
                              <Button
                                variant="outlined"
                                color="primary"
                                component="span"
                                className={classes.button}
                                disabled={loadingIrecDataset}
                                style={{
                                  marginTop: 13,
                                  border: '1px solid rgba(248,119,51, 0.5)',
                                  borderRadius: 4,
                                }}
                              >
                                Select iRec file
                              </Button>
                            </label>
                          </div>
                          <div style={{ float: 'left', marginTop: 24 }}>
                            <Typography
                              variant="caption"
                              style={{
                                color: 'rgba(0, 0, 0, 0.54)',
                                marginLeft: 10,
                              }}
                            >
                              {this.props.localIrecDataset &&
                              this.props.localIrecDataset.name
                                ? this.props.localIrecDataset.name
                                : 'No file selected'}
                            </Typography>
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 20 }}>
                        <Col xs={12}>
                          <Button
                            variant="raised"
                            color="primary"
                            disabled={
                              loadingIrecDataset ||
                              !this.props.localIrecDataset ||
                              !this.props.localIrecDataset.name
                            }
                            onClick={() => {
                              this.props.uploadIrecDataStart(
                                this.props.localIrecDataset,
                                this.props.irecCountry,
                                this.props.irecYear,
                                this.props.irecAsset,
                                this.props.irecVolume,
                                this.props.irecCustomerOrganization
                              );
                            }}
                          >
                            upload iRec data
                          </Button>
                          {loadingIrecDataset && (
                            <LoadingCircle
                              type="buttonProgress"
                              classes={classes}
                            />
                          )}
                        </Col>
                      </Row>
                    </Grid>
                  </CardContent>
                </Card>
              </TabPanel>

              <TabPanel value={selectedTab} index={8}>
                {this.renderGenerateMonthyReportForm()}
              </TabPanel>
            </Tabs>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = ({
  loginReducer,
  maintenanceReducer,
  organizationsReducer,
  certificatesReducer,
}) => {
  const {
    selectedTab,
    loading,
    loadingList,
    loadingLog,
    loadingLogList,
    loadingMaintenanceAction,
    loadingBalance,
    logList,
    demoData,
    demoDataList,
    demoDataFormOpen,
    demoDataDeleteWarningOpen,
    dialogStartDateOpen,
    startDate,
    dialogEndDateOpen,
    endDate,
    dialogWarningOpen,
    organizationId,
    organizationForMonthlyReportId,
    loadingGenerateMonthlyReportAction,
    startMonthForMonthlyReport,
    endMonthForMonthlyReport,
    startYearForMonthlyReport,
    endYearForMonthlyReport,
    destinationForMonthlyReport,
    actionId,
    localDataset,
    loadingDataset,
    localDatasetAssetMetering,
    loadingDatasetAssetMetering,
    comment,
    selectedOrganizationBalanceAccount,
  } = maintenanceReducer;

  const utilityOrganizations = organizationsReducer.utilityOrganizations;
  const organizationsForMonthlyReport =
    organizationsReducer.organizationsForMonthlyReport;
  const loadingOrganizations = organizationsReducer.loading;

  const { isAuthenticated, user } = loginReducer;
  const {
    localIrecDataset,
    loadingIrecDataset,
    irecCountry,
    irecYear,
    irecAsset,
    irecVolume,
    customerOrganizationsWithIrecFeatureEnabled,
    irecCustomerOrganization,
  } = certificatesReducer;
  return {
    selectedTab,
    loading,
    loadingList,
    loadingLog,
    loadingLogList,
    loadingMaintenanceAction,
    loadingBalance,
    loadingOrganizations,
    logList,
    demoData,
    demoDataList,
    demoDataFormOpen,
    demoDataDeleteWarningOpen,
    isAuthenticated,
    user,
    dialogStartDateOpen,
    startDate,
    dialogEndDateOpen,
    endDate,
    dialogWarningOpen,
    organizationId,
    organizationForMonthlyReportId,
    loadingGenerateMonthlyReportAction,
    startMonthForMonthlyReport,
    endMonthForMonthlyReport,
    startYearForMonthlyReport,
    endYearForMonthlyReport,
    destinationForMonthlyReport,
    actionId,
    localDataset,
    loadingDataset,
    localDatasetAssetMetering,
    loadingDatasetAssetMetering,
    utilityOrganizations,
    organizationsForMonthlyReport,
    selectedOrganizationBalanceAccount,
    comment,
    localIrecDataset,
    loadingIrecDataset,
    irecCountry,
    irecYear,
    irecAsset,
    irecVolume,
    customerOrganizationsWithIrecFeatureEnabled,
    irecCustomerOrganization,
  };
};

const mapDispatchToProps = {
  energyDataChanged,
  demoDataAssetIdChanged,
  demoDataTypeChanged,
  createDemoData,
  updateDemoData,
  deleteDemoData,
  getDemoDataList,
  getDemoData,
  getLogList,
  getLog,
  openDemoDataFormDialog,
  closeDemoDataFormDialog,
  openDemoDataFormDialog,
  openDemoDataDeleteWarningDialog,
  closeDemoDataDeleteWarningDialog,
  resetDemoData,
  toggleMaintenanceStartDateDialog,
  toggleMaintenanceEndDateDialog,
  toggleActionWarningDialog,
  triggerMaintenanceScript,
  triggerGeneratePdfCertificatesReportScript,
  // Maintenance date
  setMaintenanceStartDate,
  setMaintenanceEndDate,
  setSelectedTab,
  matchingOrganizationChanged,
  generatePdfCertificatesMonthlyReportOrganizationChanged,
  generatePdfCertificatesMonthlyReportStartMonthChanged,
  generatePdfCertificatesMonthlyReportStartYearChanged,
  generatePdfCertificatesMonthlyReportEndMonthChanged,
  generatePdfCertificatesMonthlyReportEndYearChanged,
  generatePdfCertificatesMonthlyReportDestinationChanged,
  actionChanged,
  commentChanged,
  uploadDataset,
  datasetChanged,
  uploadDatasetStart,
  // Upload asset metering
  uploadDatasetAssetMetering,
  datasetAssetMeteringChanged,
  uploadDatasetAssetMeteringStart,
  // Organization
  getOrganizations,
  getSelectedOrganizationBalanceAccount,
  irecDatasetChanged,
  uploadIrecDataStart,
  irecCountryChanged,
  irecYearChanged,
  irecAssetChanged,
  irecVolumeChanged,
  getCustomerOrganizationsWithIrecFeatureEnabled,
  irecCustomerOrganizationChanged,
};

Maintenance = withStyles(styles, { name: 'Maintenance' })(Maintenance);
Maintenance = translate('translations')(Maintenance);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withCookies(Maintenance))
);



// WEBPACK FOOTER //
// ./src/components/Maintenance.js